import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.object.entries";
import _slicedToArray from "/codebuild/output/src2728102573/src/www-public/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.from";
import _toConsumableArray from "/codebuild/output/src2728102573/src/www-public/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.function.bind";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { toLowerCase, getInputType, maskInputValue } from '../../../rrweb-snapshot/es/rrweb-snapshot.js';
import { MouseInteractions, IncrementalSource, PointerTypes } from '../../../types/dist/rrweb-types.js';
import { on, throttle, isBlocked, getWindowScroll, getWindowHeight, getWindowWidth, hookSetter, patch, legacy_isTouchEvent, nowTimestamp } from '../utils.js';
import { callbackWrapper, externalFunctionWrapper } from './error-handler.js';
import MutationBuffer from './mutation.js';
var mutationBuffers = [];

function getEventTarget(event) {
  try {
    if ('composedPath' in event) {
      var path = event.composedPath();

      if (path.length) {
        return path[0];
      }
    } else if ('path' in event && event.path.length) {
      return event.path[0];
    }
  } catch (_a) {}

  return event && event.target;
}

function initMutationObserver(options, rootEl) {
  var _a, _b;

  var mutationBuffer = new MutationBuffer();
  mutationBuffers.push(mutationBuffer);
  mutationBuffer.init(options);
  var mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
  var angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');

  if (angularZoneSymbol && window[angularZoneSymbol]) {
    mutationObserverCtor = window[angularZoneSymbol];
  }

  var observer = new mutationObserverCtor(callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
  observer.observe(rootEl, {
    attributes: true,
    attributeOldValue: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return observer;
}

function initMoveObserver(_ref) {
  var mousemoveCb = _ref.mousemoveCb,
      sampling = _ref.sampling,
      doc = _ref.doc,
      mirror = _ref.mirror;

  if (sampling.mousemove === false) {
    return function () {};
  }

  var threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
  var callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
  var positions = [];
  var timeBaseline;
  var wrappedCb = throttle(callbackWrapper(function (source) {
    var totalOffset = Date.now() - timeBaseline;
    mousemoveCb(positions.map(function (p) {
      p.timeOffset -= totalOffset;
      return p;
    }), source);
    positions = [];
    timeBaseline = null;
  }), callbackThreshold);
  var updatePosition = callbackWrapper(throttle(callbackWrapper(function (evt) {
    var target = getEventTarget(evt);

    var _ref2 = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt,
        clientX = _ref2.clientX,
        clientY = _ref2.clientY;

    if (!timeBaseline) {
      timeBaseline = nowTimestamp();
    }

    positions.push({
      x: clientX,
      y: clientY,
      id: mirror.getId(target),
      timeOffset: nowTimestamp() - timeBaseline
    });
    wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
  }), threshold, {
    trailing: false
  }));
  var handlers = [on('mousemove', updatePosition, doc), on('touchmove', updatePosition, doc), on('drag', updatePosition, doc)];
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}

function initMouseInteractionObserver(_ref3) {
  var mouseInteractionCb = _ref3.mouseInteractionCb,
      doc = _ref3.doc,
      mirror = _ref3.mirror,
      blockClass = _ref3.blockClass,
      blockSelector = _ref3.blockSelector,
      sampling = _ref3.sampling;

  if (sampling.mouseInteraction === false) {
    return function () {};
  }

  var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
  var handlers = [];
  var currentPointerType = null;

  var getHandler = function getHandler(eventKey) {
    return function (event) {
      var target = getEventTarget(event);

      if (isBlocked(target, blockClass, blockSelector, true)) {
        return;
      }

      var pointerType = null;
      var thisEventKey = eventKey;

      if ('pointerType' in event) {
        switch (event.pointerType) {
          case 'mouse':
            pointerType = PointerTypes.Mouse;
            break;

          case 'touch':
            pointerType = PointerTypes.Touch;
            break;

          case 'pen':
            pointerType = PointerTypes.Pen;
            break;
        }

        if (pointerType === PointerTypes.Touch) {
          if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) {
            thisEventKey = 'TouchStart';
          } else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) {
            thisEventKey = 'TouchEnd';
          }
        } else if (pointerType === PointerTypes.Pen) ;
      } else if (legacy_isTouchEvent(event)) {
        pointerType = PointerTypes.Touch;
      }

      if (pointerType !== null) {
        currentPointerType = pointerType;

        if (thisEventKey.startsWith('Touch') && pointerType === PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === PointerTypes.Mouse) {
          pointerType = null;
        }
      } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
        pointerType = currentPointerType;
        currentPointerType = null;
      }

      var e = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;

      if (!e) {
        return;
      }

      var id = mirror.getId(target);
      var clientX = e.clientX,
          clientY = e.clientY;
      callbackWrapper(mouseInteractionCb)(Object.assign({
        type: MouseInteractions[thisEventKey],
        id: id,
        x: clientX,
        y: clientY
      }, pointerType !== null && {
        pointerType: pointerType
      }));
    };
  };

  Object.keys(MouseInteractions).filter(function (key) {
    return Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false;
  }).forEach(function (eventKey) {
    var eventName = toLowerCase(eventKey);
    var handler = getHandler(eventKey);

    if (window.PointerEvent) {
      switch (MouseInteractions[eventKey]) {
        case MouseInteractions.MouseDown:
        case MouseInteractions.MouseUp:
          eventName = eventName.replace('mouse', 'pointer');
          break;

        case MouseInteractions.TouchStart:
        case MouseInteractions.TouchEnd:
          return;
      }
    }

    handlers.push(on(eventName, handler, doc));
  });
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}

function initScrollObserver(_ref4) {
  var scrollCb = _ref4.scrollCb,
      doc = _ref4.doc,
      mirror = _ref4.mirror,
      blockClass = _ref4.blockClass,
      blockSelector = _ref4.blockSelector,
      sampling = _ref4.sampling;
  var updatePosition = callbackWrapper(throttle(callbackWrapper(function (evt) {
    var target = getEventTarget(evt);

    if (!target || isBlocked(target, blockClass, blockSelector, true)) {
      return;
    }

    var id = mirror.getId(target);

    if (target === doc && doc.defaultView) {
      var scrollLeftTop = getWindowScroll(doc.defaultView);
      scrollCb({
        id: id,
        x: scrollLeftTop.left,
        y: scrollLeftTop.top
      });
    } else {
      scrollCb({
        id: id,
        x: target.scrollLeft,
        y: target.scrollTop
      });
    }
  }), sampling.scroll || 100));
  return on('scroll', updatePosition, doc);
}

function initViewportResizeObserver(_ref5, _ref6) {
  var viewportResizeCb = _ref5.viewportResizeCb;
  var win = _ref6.win;
  var lastH = -1;
  var lastW = -1;
  var updateDimension = callbackWrapper(throttle(callbackWrapper(function () {
    var height = getWindowHeight();
    var width = getWindowWidth();

    if (lastH !== height || lastW !== width) {
      viewportResizeCb({
        width: Number(width),
        height: Number(height)
      });
      lastH = height;
      lastW = width;
    }
  }), 200));
  return on('resize', updateDimension, win);
}

function wrapEventWithUserTriggeredFlag(v, enable) {
  var value = Object.assign({}, v);
  if (!enable) delete value.userTriggered;
  return value;
}

var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
var lastInputValueMap = new WeakMap();

function initInputObserver(_ref7) {
  var inputCb = _ref7.inputCb,
      doc = _ref7.doc,
      mirror = _ref7.mirror,
      blockClass = _ref7.blockClass,
      blockSelector = _ref7.blockSelector,
      ignoreClass = _ref7.ignoreClass,
      ignoreSelector = _ref7.ignoreSelector,
      maskInputOptions = _ref7.maskInputOptions,
      maskInputFn = _ref7.maskInputFn,
      sampling = _ref7.sampling,
      userTriggeredOnInput = _ref7.userTriggeredOnInput;

  function eventHandler(event) {
    var target = getEventTarget(event);
    var userTriggered = event.isTrusted;
    var tagName = target && target.tagName;

    if (target && tagName === 'OPTION') {
      target = target.parentElement;
    }

    if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, true)) {
      return;
    }

    if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) {
      return;
    }

    var text = target.value;
    var isChecked = false;
    var type = getInputType(target) || '';

    if (type === 'radio' || type === 'checkbox') {
      isChecked = target.checked;
    } else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) {
      text = maskInputValue({
        element: target,
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type,
        value: text,
        maskInputFn: maskInputFn
      });
    }

    cbWithDedup(target, callbackWrapper(wrapEventWithUserTriggeredFlag)({
      text: text,
      isChecked: isChecked,
      userTriggered: userTriggered
    }, userTriggeredOnInput));
    var name = target.name;

    if (type === 'radio' && name && isChecked) {
      doc.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")).forEach(function (el) {
        if (el !== target) {
          cbWithDedup(el, callbackWrapper(wrapEventWithUserTriggeredFlag)({
            text: el.value,
            isChecked: !isChecked,
            userTriggered: false
          }, userTriggeredOnInput));
        }
      });
    }
  }

  function cbWithDedup(target, v) {
    var lastInputValue = lastInputValueMap.get(target);

    if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
      lastInputValueMap.set(target, v);
      var id = mirror.getId(target);
      callbackWrapper(inputCb)(Object.assign(Object.assign({}, v), {
        id: id
      }));
    }
  }

  var events = sampling.input === 'last' ? ['change'] : ['input', 'change'];
  var handlers = events.map(function (eventName) {
    return on(eventName, callbackWrapper(eventHandler), doc);
  });
  var currentWindow = doc.defaultView;

  if (!currentWindow) {
    return function () {
      handlers.forEach(function (h) {
        return h();
      });
    };
  }

  var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
  var hookProperties = [[currentWindow.HTMLInputElement.prototype, 'value'], [currentWindow.HTMLInputElement.prototype, 'checked'], [currentWindow.HTMLSelectElement.prototype, 'value'], [currentWindow.HTMLTextAreaElement.prototype, 'value'], [currentWindow.HTMLSelectElement.prototype, 'selectedIndex'], [currentWindow.HTMLOptionElement.prototype, 'selected']];

  if (propertyDescriptor && propertyDescriptor.set) {
    handlers.push.apply(handlers, _toConsumableArray(hookProperties.map(function (p) {
      return hookSetter(p[0], p[1], {
        set: function set() {
          callbackWrapper(eventHandler)({
            target: this,
            isTrusted: false
          });
        }
      }, false, currentWindow);
    })));
  }

  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}

function getNestedCSSRulePositions(rule) {
  var positions = [];

  function recurse(childRule, pos) {
    if (hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
      var rules = Array.from(childRule.parentRule.cssRules);
      var index = rules.indexOf(childRule);
      pos.unshift(index);
    } else if (childRule.parentStyleSheet) {
      var _rules = Array.from(childRule.parentStyleSheet.cssRules);

      var _index = _rules.indexOf(childRule);

      pos.unshift(_index);
    }

    return pos;
  }

  return recurse(rule, positions);
}

function getIdAndStyleId(sheet, mirror, styleMirror) {
  var id, styleId;
  if (!sheet) return {};
  if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);else styleId = styleMirror.getId(sheet);
  return {
    styleId: styleId,
    id: id
  };
}

function initStyleSheetObserver(_ref8, _ref9) {
  var styleSheetRuleCb = _ref8.styleSheetRuleCb,
      mirror = _ref8.mirror,
      stylesheetManager = _ref8.stylesheetManager;
  var win = _ref9.win;

  if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
    return function () {};
  }

  var insertRule = win.CSSStyleSheet.prototype.insertRule;
  win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
    apply: callbackWrapper(function (target, thisArg, argumentsList) {
      var _argumentsList = _slicedToArray(argumentsList, 2),
          rule = _argumentsList[0],
          index = _argumentsList[1];

      var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror),
          id = _getIdAndStyleId.id,
          styleId = _getIdAndStyleId.styleId;

      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id: id,
          styleId: styleId,
          adds: [{
            rule: rule,
            index: index
          }]
        });
      }

      return externalFunctionWrapper(function () {
        return target.apply(thisArg, argumentsList);
      })();
    })
  });
  var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
  win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
    apply: callbackWrapper(function (target, thisArg, argumentsList) {
      var _argumentsList2 = _slicedToArray(argumentsList, 1),
          index = _argumentsList2[0];

      var _getIdAndStyleId2 = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror),
          id = _getIdAndStyleId2.id,
          styleId = _getIdAndStyleId2.styleId;

      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id: id,
          styleId: styleId,
          removes: [{
            index: index
          }]
        });
      }

      return externalFunctionWrapper(function () {
        return target.apply(thisArg, argumentsList);
      })();
    })
  });
  var replace;

  if (win.CSSStyleSheet.prototype.replace) {
    replace = win.CSSStyleSheet.prototype.replace;
    win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
      apply: callbackWrapper(function (target, thisArg, argumentsList) {
        var _argumentsList3 = _slicedToArray(argumentsList, 1),
            text = _argumentsList3[0];

        var _getIdAndStyleId3 = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror),
            id = _getIdAndStyleId3.id,
            styleId = _getIdAndStyleId3.styleId;

        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id: id,
            styleId: styleId,
            replace: text
          });
        }

        return target.apply(thisArg, argumentsList);
      })
    });
  }

  var replaceSync;

  if (win.CSSStyleSheet.prototype.replaceSync) {
    replaceSync = win.CSSStyleSheet.prototype.replaceSync;
    win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
      apply: callbackWrapper(function (target, thisArg, argumentsList) {
        var _argumentsList4 = _slicedToArray(argumentsList, 1),
            text = _argumentsList4[0];

        var _getIdAndStyleId4 = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror),
            id = _getIdAndStyleId4.id,
            styleId = _getIdAndStyleId4.styleId;

        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id: id,
            styleId: styleId,
            replaceSync: text
          });
        }

        return target.apply(thisArg, argumentsList);
      })
    });
  }

  var supportedNestedCSSRuleTypes = {};

  if (canMonkeyPatchNestedCSSRule('CSSGroupingRule')) {
    supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
  } else {
    if (canMonkeyPatchNestedCSSRule('CSSMediaRule')) {
      supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
    }

    if (canMonkeyPatchNestedCSSRule('CSSConditionRule')) {
      supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
    }

    if (canMonkeyPatchNestedCSSRule('CSSSupportsRule')) {
      supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
  }

  var unmodifiedFunctions = {};
  Object.entries(supportedNestedCSSRuleTypes).forEach(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
        typeKey = _ref11[0],
        type = _ref11[1];

    unmodifiedFunctions[typeKey] = {
      insertRule: type.prototype.insertRule,
      deleteRule: type.prototype.deleteRule
    };
    type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
      apply: callbackWrapper(function (target, thisArg, argumentsList) {
        var _argumentsList5 = _slicedToArray(argumentsList, 2),
            rule = _argumentsList5[0],
            index = _argumentsList5[1];

        var _getIdAndStyleId5 = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror),
            id = _getIdAndStyleId5.id,
            styleId = _getIdAndStyleId5.styleId;

        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id: id,
            styleId: styleId,
            adds: [{
              rule: rule,
              index: [].concat(_toConsumableArray(getNestedCSSRulePositions(thisArg)), [index || 0])
            }]
          });
        }

        return target.apply(thisArg, argumentsList);
      })
    });
    type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
      apply: callbackWrapper(function (target, thisArg, argumentsList) {
        var _argumentsList6 = _slicedToArray(argumentsList, 1),
            index = _argumentsList6[0];

        var _getIdAndStyleId6 = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror),
            id = _getIdAndStyleId6.id,
            styleId = _getIdAndStyleId6.styleId;

        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id: id,
            styleId: styleId,
            removes: [{
              index: [].concat(_toConsumableArray(getNestedCSSRulePositions(thisArg)), [index])
            }]
          });
        }

        return target.apply(thisArg, argumentsList);
      })
    });
  });
  return callbackWrapper(function () {
    win.CSSStyleSheet.prototype.insertRule = insertRule;
    win.CSSStyleSheet.prototype.deleteRule = deleteRule;
    replace && (win.CSSStyleSheet.prototype.replace = replace);
    replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
    Object.entries(supportedNestedCSSRuleTypes).forEach(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
          typeKey = _ref13[0],
          type = _ref13[1];

      type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
      type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
    });
  });
}

function initAdoptedStyleSheetObserver(_ref14, host) {
  var mirror = _ref14.mirror,
      stylesheetManager = _ref14.stylesheetManager;

  var _a, _b, _c;

  var hostId = null;
  if (host.nodeName === '#document') hostId = mirror.getId(host);else hostId = mirror.getId(host.host);
  var patchTarget = host.nodeName === '#document' ? (_a = host.defaultView) === null || _a === void 0 ? void 0 : _a.Document : (_c = (_b = host.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView) === null || _c === void 0 ? void 0 : _c.ShadowRoot;
  var originalPropertyDescriptor = (patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype, 'adoptedStyleSheets') : undefined;
  if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function () {};
  Object.defineProperty(host, 'adoptedStyleSheets', {
    configurable: originalPropertyDescriptor.configurable,
    enumerable: originalPropertyDescriptor.enumerable,
    get: function get() {
      var _a;

      return (_a = originalPropertyDescriptor.get) === null || _a === void 0 ? void 0 : _a.call(this);
    },
    set: function set(sheets) {
      var _a;

      var result = (_a = originalPropertyDescriptor.set) === null || _a === void 0 ? void 0 : _a.call(this, sheets);

      if (hostId !== null && hostId !== -1) {
        try {
          stylesheetManager.adoptStyleSheets(sheets, hostId);
        } catch (e) {}
      }

      return result;
    }
  });
  return callbackWrapper(function () {
    Object.defineProperty(host, 'adoptedStyleSheets', {
      configurable: originalPropertyDescriptor.configurable,
      enumerable: originalPropertyDescriptor.enumerable,
      get: originalPropertyDescriptor.get,
      set: originalPropertyDescriptor.set
    });
  });
}

function initStyleDeclarationObserver(_ref15, _ref16) {
  var styleDeclarationCb = _ref15.styleDeclarationCb,
      mirror = _ref15.mirror,
      ignoreCSSAttributes = _ref15.ignoreCSSAttributes,
      stylesheetManager = _ref15.stylesheetManager;
  var win = _ref16.win;
  var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
  win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
    apply: callbackWrapper(function (target, thisArg, argumentsList) {
      var _a;

      var _argumentsList7 = _slicedToArray(argumentsList, 3),
          property = _argumentsList7[0],
          value = _argumentsList7[1],
          priority = _argumentsList7[2];

      if (ignoreCSSAttributes.has(property)) {
        return setProperty.apply(thisArg, [property, value, priority]);
      }

      var _getIdAndStyleId7 = getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror),
          id = _getIdAndStyleId7.id,
          styleId = _getIdAndStyleId7.styleId;

      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id: id,
          styleId: styleId,
          set: {
            property: property,
            value: value,
            priority: priority
          },
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }

      return target.apply(thisArg, argumentsList);
    })
  });
  var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
  win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
    apply: callbackWrapper(function (target, thisArg, argumentsList) {
      var _a;

      var _argumentsList8 = _slicedToArray(argumentsList, 1),
          property = _argumentsList8[0];

      if (ignoreCSSAttributes.has(property)) {
        return removeProperty.apply(thisArg, [property]);
      }

      var _getIdAndStyleId8 = getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror),
          id = _getIdAndStyleId8.id,
          styleId = _getIdAndStyleId8.styleId;

      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id: id,
          styleId: styleId,
          remove: {
            property: property
          },
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }

      return target.apply(thisArg, argumentsList);
    })
  });
  return callbackWrapper(function () {
    win.CSSStyleDeclaration.prototype.setProperty = setProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
  });
}

function initMediaInteractionObserver(_ref17) {
  var mediaInteractionCb = _ref17.mediaInteractionCb,
      blockClass = _ref17.blockClass,
      blockSelector = _ref17.blockSelector,
      mirror = _ref17.mirror,
      sampling = _ref17.sampling,
      doc = _ref17.doc;
  var handler = callbackWrapper(function (type) {
    return throttle(callbackWrapper(function (event) {
      var target = getEventTarget(event);

      if (!target || isBlocked(target, blockClass, blockSelector, true)) {
        return;
      }

      var currentTime = target.currentTime,
          volume = target.volume,
          muted = target.muted,
          playbackRate = target.playbackRate;
      mediaInteractionCb({
        type: type,
        id: mirror.getId(target),
        currentTime: currentTime,
        volume: volume,
        muted: muted,
        playbackRate: playbackRate
      });
    }), sampling.media || 500);
  });
  var handlers = [on('play', handler(0), doc), on('pause', handler(1), doc), on('seeked', handler(2), doc), on('volumechange', handler(3), doc), on('ratechange', handler(4), doc)];
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}

function initFontObserver(_ref18) {
  var fontCb = _ref18.fontCb,
      doc = _ref18.doc;
  var win = doc.defaultView;

  if (!win) {
    return function () {};
  }

  var handlers = [];
  var fontMap = new WeakMap();
  var originalFontFace = win.FontFace;

  win.FontFace = function FontFace(family, source, descriptors) {
    var fontFace = new originalFontFace(family, source, descriptors);
    fontMap.set(fontFace, {
      family: family,
      buffer: typeof source !== 'string',
      descriptors: descriptors,
      fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
    });
    return fontFace;
  };

  var restoreHandler = patch(doc.fonts, 'add', function (original) {
    return function (fontFace) {
      setTimeout(callbackWrapper(function () {
        var p = fontMap.get(fontFace);

        if (p) {
          fontCb(p);
          fontMap["delete"](fontFace);
        }
      }), 0);
      return original.apply(this, [fontFace]);
    };
  });
  handlers.push(function () {
    win.FontFace = originalFontFace;
  });
  handlers.push(restoreHandler);
  return callbackWrapper(function () {
    handlers.forEach(function (h) {
      return h();
    });
  });
}

function initSelectionObserver(param) {
  var doc = param.doc,
      mirror = param.mirror,
      blockClass = param.blockClass,
      blockSelector = param.blockSelector,
      selectionCb = param.selectionCb;
  var collapsed = true;
  var updateSelection = callbackWrapper(function () {
    var selection = doc.getSelection();
    if (!selection || collapsed && (selection === null || selection === void 0 ? void 0 : selection.isCollapsed)) return;
    collapsed = selection.isCollapsed || false;
    var ranges = [];
    var count = selection.rangeCount || 0;

    for (var i = 0; i < count; i++) {
      var range = selection.getRangeAt(i);
      var startContainer = range.startContainer,
          startOffset = range.startOffset,
          endContainer = range.endContainer,
          endOffset = range.endOffset;
      var blocked = isBlocked(startContainer, blockClass, blockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, true);
      if (blocked) continue;
      ranges.push({
        start: mirror.getId(startContainer),
        startOffset: startOffset,
        end: mirror.getId(endContainer),
        endOffset: endOffset
      });
    }

    selectionCb({
      ranges: ranges
    });
  });
  updateSelection();
  return on('selectionchange', updateSelection);
}

function mergeHooks(o, hooks) {
  var mutationCb = o.mutationCb,
      mousemoveCb = o.mousemoveCb,
      mouseInteractionCb = o.mouseInteractionCb,
      scrollCb = o.scrollCb,
      viewportResizeCb = o.viewportResizeCb,
      inputCb = o.inputCb,
      mediaInteractionCb = o.mediaInteractionCb,
      styleSheetRuleCb = o.styleSheetRuleCb,
      styleDeclarationCb = o.styleDeclarationCb,
      canvasMutationCb = o.canvasMutationCb,
      fontCb = o.fontCb,
      selectionCb = o.selectionCb;

  o.mutationCb = function () {
    if (hooks.mutation) {
      hooks.mutation.apply(hooks, arguments);
    }

    mutationCb.apply(void 0, arguments);
  };

  o.mousemoveCb = function () {
    if (hooks.mousemove) {
      hooks.mousemove.apply(hooks, arguments);
    }

    mousemoveCb.apply(void 0, arguments);
  };

  o.mouseInteractionCb = function () {
    if (hooks.mouseInteraction) {
      hooks.mouseInteraction.apply(hooks, arguments);
    }

    mouseInteractionCb.apply(void 0, arguments);
  };

  o.scrollCb = function () {
    if (hooks.scroll) {
      hooks.scroll.apply(hooks, arguments);
    }

    scrollCb.apply(void 0, arguments);
  };

  o.viewportResizeCb = function () {
    if (hooks.viewportResize) {
      hooks.viewportResize.apply(hooks, arguments);
    }

    viewportResizeCb.apply(void 0, arguments);
  };

  o.inputCb = function () {
    if (hooks.input) {
      hooks.input.apply(hooks, arguments);
    }

    inputCb.apply(void 0, arguments);
  };

  o.mediaInteractionCb = function () {
    if (hooks.mediaInteaction) {
      hooks.mediaInteaction.apply(hooks, arguments);
    }

    mediaInteractionCb.apply(void 0, arguments);
  };

  o.styleSheetRuleCb = function () {
    if (hooks.styleSheetRule) {
      hooks.styleSheetRule.apply(hooks, arguments);
    }

    styleSheetRuleCb.apply(void 0, arguments);
  };

  o.styleDeclarationCb = function () {
    if (hooks.styleDeclaration) {
      hooks.styleDeclaration.apply(hooks, arguments);
    }

    styleDeclarationCb.apply(void 0, arguments);
  };

  o.canvasMutationCb = function () {
    if (hooks.canvasMutation) {
      hooks.canvasMutation.apply(hooks, arguments);
    }

    canvasMutationCb.apply(void 0, arguments);
  };

  o.fontCb = function () {
    if (hooks.font) {
      hooks.font.apply(hooks, arguments);
    }

    fontCb.apply(void 0, arguments);
  };

  o.selectionCb = function () {
    if (hooks.selection) {
      hooks.selection.apply(hooks, arguments);
    }

    selectionCb.apply(void 0, arguments);
  };
}

function initObservers(o) {
  var hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentWindow = o.doc.defaultView;

  if (!currentWindow) {
    return function () {};
  }

  mergeHooks(o, hooks);
  var mutationObserver;

  if (o.recordDOM) {
    mutationObserver = initMutationObserver(o, o.doc);
  }

  var mousemoveHandler = initMoveObserver(o);
  var mouseInteractionHandler = initMouseInteractionObserver(o);
  var scrollHandler = initScrollObserver(o);
  var viewportResizeHandler = initViewportResizeObserver(o, {
    win: currentWindow
  });
  var inputHandler = initInputObserver(o);
  var mediaInteractionHandler = initMediaInteractionObserver(o);

  var styleSheetObserver = function styleSheetObserver() {};

  var adoptedStyleSheetObserver = function adoptedStyleSheetObserver() {};

  var styleDeclarationObserver = function styleDeclarationObserver() {};

  var fontObserver = function fontObserver() {};

  if (o.recordDOM) {
    styleSheetObserver = initStyleSheetObserver(o, {
      win: currentWindow
    });
    adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o, o.doc);
    styleDeclarationObserver = initStyleDeclarationObserver(o, {
      win: currentWindow
    });

    if (o.collectFonts) {
      fontObserver = initFontObserver(o);
    }
  }

  var selectionObserver = initSelectionObserver(o);
  var pluginHandlers = [];

  var _iterator = _createForOfIteratorHelper(o.plugins),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var plugin = _step.value;
      pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return callbackWrapper(function () {
    mutationBuffers.forEach(function (b) {
      return b.reset();
    });
    mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
    mousemoveHandler();
    mouseInteractionHandler();
    scrollHandler();
    viewportResizeHandler();
    inputHandler();
    mediaInteractionHandler();
    styleSheetObserver();
    adoptedStyleSheetObserver();
    styleDeclarationObserver();
    fontObserver();
    selectionObserver();
    pluginHandlers.forEach(function (h) {
      return h();
    });
  });
}

function hasNestedCSSRule(prop) {
  return typeof window[prop] !== 'undefined';
}

function canMonkeyPatchNestedCSSRule(prop) {
  return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}

export { INPUT_TAGS, initAdoptedStyleSheetObserver, initMutationObserver, initObservers, initScrollObserver, mutationBuffers };